import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../coupons/Coupon.css';
import { useUser } from '../context/UserContext';
import { hasPrivilege } from '../utils/hasPrivilege';
import { CSVLink } from 'react-csv';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement, CategoryScale } from 'chart.js';
import Select from 'react-select';
import { FiChevronDown, FiRefreshCw } from 'react-icons/fi';

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale);

const Summer = () => {
  const token = localStorage.getItem('auth-token');
  const { userData } = useUser();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setrowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [apiData, setApiData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const { selectedCenter, setSelectedCenter } = useUser();
  const today = new Date();
  const tenDaysAgo = new Date();
  tenDaysAgo.setDate(today.getDate() - 10);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState(today.toISOString().split('T')[0]);
  const [selectedAcademy, setSelectedAcademy] = useState('');
  const [selectedSport, setSelectedSport] = useState('');
  const headers = [
    { label: "Academy Name", key: "academy_name" },
    { label: "Name", key: "name" },
    { label: "Mobile Number", key: "mobile_number" },
    { label: "Sport Name", key: "sport_name" },
    { label: "Joining Date", key: "joining_date" },
    { label: "Expiry Date", key: "expiry_date" },
    { label: "Sessions", key: "sessions" },
    { label: "Start Time", key: "start_time" },
    { label: "End Time", key: "end_time" },
    { label: "Plan/Batch", key: "plan_name" },
    { label: "Amount", key: "total_amount" },
    { label: "Purchase at", key: "created_at" },
  ];
  const [academies, setAcademies] = useState([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  useEffect(() => {

    if (selectedCenter) {
      setSelectedAcademy(selectedCenter);
    } else if (userData?.userType === "ACADEMY") {
      if (userData.academyIds?.length > 0) {
        const validAcademyId = userData.academyIds?.find((academyId) =>
          apiData.some((item) => Number(item.academy_id) === Number(academyId))
        );


        if (validAcademyId) {
          setSelectedAcademy("allAcademies");
        } else {
          setSelectedAcademy("");
        }
      } else {
        setSelectedAcademy("");
      }
    } else {
      setSelectedAcademy("");
    }

    return () => {
      setSelectedAcademy("");
    };
  }, [userData, selectedCenter, apiData]);



    const fetchPurchaseData = async () => {
      setLoading(true);
      setError(null);
  
      try {
        const response = await fetch(process.env.REACT_APP_API_PURCHASE, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });
  
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
  
        const data = await response.json();
  
        if (data.success) {
          const fetchedData = data.data.apiData || [];
          const fetchedAcademies = data.data.academies || [];
  
          setApiData(fetchedData);
          setFilteredData(fetchedData);
          setAcademies(fetchedAcademies);
  
          if (fetchedData.length > 0) {
            const earliestDate = fetchedData
              .map((item) => new Date(item.joining_date))
              .reduce((min, date) => (date < min ? date : min), new Date());
  
            const today = new Date();
            setEndDate(today.toISOString().split('T')[0]);
          }
        } else {
          throw new Error('API response unsuccessful');
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    useEffect(() => {
    fetchPurchaseData();
  }, []);
  



  const adjustedEndDate = endDate ? new Date(new Date(endDate).setHours(23, 59, 59, 999)) : null;

  useEffect(() => {
    let updatedData = apiData.filter((item) => {
      const itemJoiningDate = item.created_at ? new Date(item.created_at) : new Date();
      const itemExpiryDate = item.created_at
        ? new Date(new Date(item.created_at).setHours(23, 59, 59, 999))
        : new Date();

      const matchesSearch = searchTerm
        ? Object.values(item).join(' ').toLowerCase().includes(searchTerm.toLowerCase())
        : true;

      const matchesStartDate = startDate ? itemJoiningDate >= new Date(startDate) : true;
      const matchesEndDate = adjustedEndDate ? itemExpiryDate <= adjustedEndDate : true;

      const matchesAcademy = selectedAcademy === "allAcademies"
        ? userData.academyIds.includes(Number(item.academy_id))
        : selectedAcademy
          ? Number(item.academy_id) === Number(selectedAcademy)
          : true;

      const matchesSport = selectedSport ? item.sport_name === selectedSport : true;

      return matchesSearch && matchesStartDate && matchesEndDate && matchesAcademy && matchesSport;
    });

    setFilteredData(updatedData);
    setCurrentPage(1);
  }, [searchTerm, startDate, endDate, selectedAcademy, selectedSport, apiData, userData.academyIds]);


  const [sortConfig, setSortConfig] = useState({ key: 'created_at', direction: 'descending' });
  const handleSort = (columnKey) => {
    let direction = 'ascending';

    if (sortConfig.key === columnKey && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }

    setSortConfig({ key: columnKey, direction });
  };

  const sortData = (data) => {
    const { key, direction } = sortConfig;

    if (!key) return data;

    const sorted = [...data].sort((a, b) => {
      if (key === 'created_at') {
        const aDate = new Date(a[key]);
        const bDate = new Date(b[key]);
        return direction === 'ascending' ? aDate - bDate : bDate - aDate;
      }

      const aValue = a[key];
      const bValue = b[key];

      if (aValue < bValue) return direction === 'ascending' ? -1 : 1;
      if (aValue > bValue) return direction === 'ascending' ? 1 : -1;
      return 0;
    });

    return sorted;
  };
  const sortedData = sortData(filteredData);

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = sortedData.slice(indexOfFirstRow, indexOfLastRow);

  const totalPages = Math.ceil(sortedData.length / rowsPerPage);

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((prevPage) => prevPage - 1);
  };

  const generatePageNumbers = () => {
    const pages = [];
    const totalPagesToShow = 5;

    if (totalPages <= totalPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      if (currentPage > 3) pages.push('...');
      for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
        pages.push(i);
      }
      if (currentPage < totalPages - 2) pages.push('...');
      pages.push(totalPages);
    }
    return pages;
  };

  const renderPagination = () => {
    return generatePageNumbers().map((page, index) =>
      typeof page === 'number' ? (
        <button
          key={index}
          className={`page-number ${currentPage === page ? 'active' : ''}`}
          onClick={() => handlePageClick(page)}
        >
          {page}
        </button>
      ) : (
        <span key={index} className="pagination-dots">
          {page}
        </span>
      )
    );
  };

  const handleItemsPerPageChange = (event) => {
    setrowsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };
  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}`;
  }

  const createdAt = "2025-01-23T06:22:09.000+00:00";
  const getSportDistribution = () => {
    const sportCount = { Badminton: 0, Swimming: 0 };

    filteredData.forEach((item) => {
      if (item.sport_name === 'Badminton') {
        sportCount.Badminton += 1;
      } else if (item.sport_name === 'Swimming') {
        sportCount.Swimming += 1;
      }
    });

    return {
      labels: ['Badminton', 'Swimming'],
      datasets: [
        {
          data: [sportCount.Badminton, sportCount.Swimming],
          backgroundColor: ['#A79277', '#D1BB9E'],
        },
      ],
    };
  };

  const getAcademyDistribution = () => {
    const academyCount = {};

    filteredData.forEach((item) => {
      const academy = item.academy_name;
      academyCount[academy] = (academyCount[academy] || 0) + 1;
    });

    const academyLabels = Object.keys(academyCount);
    const academyData = Object.values(academyCount);
    const academyColors = [
      '#36A2EB', '#FFCE56', '#FF9F40', '#4BC0C0', '#9966FF', '#FF6384', '#C9CBCF', '#8BC34A',
      '#F7464A', '#46BFBD', '#FDB45C', '#949FB1', '#FF5733', '#33FF57', '#FF33A1', '#33FFF5',
      '#A833FF', '#FF3380', '#BFFF00', '#FF9900', '#00BFFF', '#FF1493', '#FFD700', '#32CD32',
      '#DC143C', '#20B2AA', '#FF4500', '#8B0000', '#ADFF2F', '#9400D3'
    ];

    return {
      labels: academyLabels,
      datasets: [
        {
          data: academyData,
          backgroundColor: academyData.map((_, index) => academyColors[index] || '#FF6384'),
        },
      ],
    };
  };

  const options = {
    plugins: {
      legend: { display: false },
      tooltip: { enabled: true },
    },
  };
  const chartData = getAcademyDistribution();

  const getBadmintonBatchDistribution = () => {
    const batchCount = {};

    filteredData.forEach((item) => {
      if (item.sport_name === 'Badminton' && item.plan_name) {
        const batch = item.plan_name;
        if (batchCount[batch]) {
          batchCount[batch] += 1;
        } else {
          batchCount[batch] = 1;
        }
      }
    });

    const batchLabels = Object.keys(batchCount);
    const batchData = Object.values(batchCount);

    const batchColors = ['#36A2EB', '#FFCE56', '#FF9F40', '#4BC0C0', '#9966FF', '#FF6384', '#C9CBCF', '#8BC34A', '#F7464A', '#46BFBD', '#FDB45C', '#949FB1']

    return {
      labels: batchLabels,
      datasets: [
        {
          data: batchData,
          backgroundColor: batchLabels.map((_, index) => batchColors[index] || '#FF6384'),
        },
      ],
    };
  };

  const getSwimmingPlanDistribution = () => {
    const planCount = {};

    filteredData.forEach((item) => {
      if (item.sport_name === 'Swimming' && item.plan_name) {
        const plan = item.plan_name;
        if (planCount[plan]) {
          planCount[plan] += 1;
        } else {
          planCount[plan] = 1;
        }
      }
    });

    const planLabels = Object.keys(planCount);
    const planData = Object.values(planCount);

    const planColors = ['#36A2EB', '#FFCE56', '#FF9F40', '#4BC0C0', '#9966FF', '#FF6384', '#C9CBCF', '#8BC34A', '#F7464A', '#46BFBD', '#FDB45C', '#949FB1']

    return {
      labels: planLabels,
      datasets: [
        {
          data: planData,
          backgroundColor: planLabels.map((_, index) => planColors[index] || '#36A2EB'),
        },
      ],
    };
  };
  const totalEntries = filteredData.length;
  const indexOfFirstEntry = totalEntries > 0 ? (currentPage - 1) * rowsPerPage + 1 : 0;
  const indexOfLastEntry = totalEntries > 0 ? Math.min(currentPage * rowsPerPage, totalEntries) : 0;
  const academyOptions = userData.userType === "ACADEMY"
    ? [
      { value: 'allAcademies', label: 'All Academies' },
      ...userData.academyIds
        .map(id => {
          const academy = academies.find(a => a.id === id);
          return academy ? { value: academy.id, label: academy.name } : null;
        })
        .filter(Boolean)
    ]
    : [
      { value: '', label: 'All Academies' },
      ...academies.map(a => ({ value: a.id, label: a.name }))
    ];

  const sportOptions = [
    { value: '', label: 'All Sports' },
    ...[...new Set(
      apiData
        .filter(item => {
          if (selectedAcademy === 'allAcademies') {
            return userData.academyIds.includes(Number(item.academy_id));
          } else if (selectedAcademy) {
            return Number(item.academy_id) === Number(selectedAcademy);
          }
          return true;
        })
        .map(item => item.sport_name)
    )].map(sport => ({
      value: sport,
      label: sport,
    }))
  ];


  return (
    <div className="enrollment-container">
      <div className="sales-filters-login">
    

        <div className="floating-select">
          <Select
            options={academyOptions}
            value={academyOptions.find(option => String(option.value) === String(selectedAcademy))}
            onChange={(selectedOption) => setSelectedAcademy(selectedOption?.value ?? '')}
            classNamePrefix="react-select"
            placeholder="Select Academy"
            className={`sales-filter-court-booking ${selectedAcademy ? "has-value" : ""}`}
            menuPortalTarget={document.body}
            styles={{
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />
          {selectedAcademy && <label htmlFor="academy">Academy</label>}
        </div>


        <div className="floating-select">
          <Select
            options={sportOptions}
            value={sportOptions.find(option => option.value === selectedSport)}
            onChange={(selectedOption) => setSelectedSport(selectedOption?.value || '')}
            classNamePrefix="react-select"
            className={`sales-filter-court-booking ${selectedSport ? "has-value" : ""}`}
            placeholder="Select Sport"
            menuPortalTarget={document.body}
            styles={{
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />
          {selectedSport && <label htmlFor="sport">Sport</label>}
        </div>

        <div className="floating-select">
          <input
            type="date"
            placeholder="Trial Start Date"
            name="trialStartDate"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            onClick={(e) => e.target.showPicker()}
            max={new Date().toISOString().split('T')[0]}
            className={`sales-filter-court-booking has-value`}
          />
    <label htmlFor="trialStartDate">Start Date</label>
        </div>

        <div className="floating-select">
          <input
            type="date"
            placeholder="Trial End Date"
            name="trialEndDate"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            onClick={(e) => e.target.showPicker()}
            max={new Date().toISOString().split('T')[0]}
            className={`sales-filter-court-booking has-value`}
          />
     <label htmlFor="trialEndDate">End Date</label>
        </div>
      </div>
      <div className="unique-charts-container">
        {getSportDistribution().datasets[0].data.some((value) => value > 0) && (
          <div className="unique-chart-container badminton-vs-swimming">
            <h3 style={{ textAlign: 'center' }}>Sport-Wise Enrollment</h3>
            <Pie data={getSportDistribution()} />
          </div>
        )}

        {chartData.datasets[0].data.some((value) => value > 0) ? (
          <div className="unique-chart-container academy-enrollment">
            <h3 style={{ textAlign: 'center' }}>Academy Enrollment Distribution</h3>
            <Pie data={chartData} options={options} />
          </div>
        ) : null}

        {getBadmintonBatchDistribution().datasets[0].data.some((value) => value > 0) && (
          <div className="unique-chart-container badminton-batch">
            <h3 style={{ textAlign: 'center' }}>Badminton Plan Distribution</h3>
            <Pie data={getBadmintonBatchDistribution()} />
          </div>
        )}

        {getSwimmingPlanDistribution().datasets[0].data.some((value) => value > 0) && (
          <div className="unique-chart-container swimming-plan">
            <h3 style={{ textAlign: 'center' }}>Swimming Batch Distribution</h3>
            <Pie data={getSwimmingPlanDistribution()} />
          </div>
        )}
      </div>



      <div className="search-create-container">
        <div className="input-container">
          <input
            type="text"
            id="searchInput"
            placeholder=""
            className={`search-input ${searchTerm ? "has-value" : ""}`}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <label htmlFor="searchInput" className="floating-label">
            🔍 Search
          </label>
        </div>
        <CSVLink
          data={filteredData}
          headers={headers}
          filename="SummerEnrollmentSheet.csv"
          className="btn btn-primary no-decoration"
        >
          <button className="csv_button" type="button" >
            <span
              className="button__text"

            >
              Export CSV
            </span>
            <span className="button__icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35" className="svg">
                <path d="M17.5,22.131a1.249,1.249,0,0,1-1.25-1.25V2.187a1.25,1.25,0,0,1,2.5,0V20.881A1.25,1.25,0,0,1,17.5,22.131Z"></path>
                <path d="M17.5,22.693a3.189,3.189,0,0,1-2.262-.936L8.487,15.006a1.249,1.249,0,0,1,1.767-1.767l6.751,6.751a.7.7,0,0,0,.99,0l6.751-6.751a1.25,1.25,0,0,1,1.768,1.767l-6.752,6.751A3.191,3.191,0,0,1,17.5,22.693Z"></path>
                <path d="M31.436,34.063H3.564A3.318,3.318,0,0,1,.25,30.749V22.011a1.25,1.25,0,0,1,2.5,0v8.738a.815.815,0,0,0,.814.814H31.436a.815.815,0,0,0,.814-.814V22.011a1.25,1.25,0,1,1,2.5,0v8.738A3.318,3.318,0,0,1,31.436,34.063Z"></path>
              </svg>
            </span>
          </button>
        </CSVLink>
      </div>

      <div className="items-and-dues">
        <select className="items-per-page-select" value={rowsPerPage} onChange={handleItemsPerPageChange}>
          <option value={10}>10 items per page</option>
          <option value={50}>50 items per page</option>
          <option value={75}>75 items per page</option>
        <option value={100}>100 items per page</option>
      </select>
      <div className="pagination-selector">
          <div className="button-group">
            <div className="group-label">Items per page:</div>
            <div className="button-options">
              {[10, 50, 75, 100].map((option) => (
                <button
                  key={option}
                  onClick={() =>
                    handleItemsPerPageChange({ target: { value: option } })
                  }
                  className={`page-button ${rowsPerPage === option ? 'active' : ''}`}
                >
                  <span className="button-text">{option}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
        <button className="tt-action-btn" onClick={fetchPurchaseData}>
          <FiRefreshCw className={`refresh-icon ${loading ? 'spin' : ''}`} />
          Refresh
        </button>
      </div>
      {loading && (
        <div className="premium-loader">
          <div className="progress-track">
            <div className="progress-bar"></div>
          </div>
          <div className="status-text">
            <span>L</span>
            <span>O</span>
            <span>A</span>
            <span>D</span>
            <span>I</span>
            <span>N</span>
            <span>G</span>
          </div>
        </div>
      )}

      {error && <div className="error-message">{error}</div>}
      {!loading && !error && filteredData.length === 0 && (
        <div className="error-message">No data available</div>
      )}
      
      <div className="tt-table-container">
        <table className="tt-table">
          <thead>
            <tr>
              {headers.map(({ key, label }) => (
                <th key={key} className="challenges-column" onClick={() => handleSort(key)}>
                  <div className="th-content">
                    <span>{label}</span>
                    <FiChevronDown
                      className={`sort-icon ${sortConfig.key === key ? 'active' : ''
                        } ${sortConfig.key === key && sortConfig.direction === 'descending' ? 'desc' : ''}`}
                    />
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {currentRows.map((item) => (
              <tr key={item.id}>
                <td>{item.academy_name}</td>
                <td>{item.name}</td>
                <td>{item.mobile_number}</td>
                <td>{item.sport_name}</td>
                <td>{item.joining_date}</td>
                <td>{item.expiry_date}</td>
                <td>{item.sessions || '-'}</td>
                <td>
                  {item.start_time
                    ? (() => {
                      let [hours, minutes] = item.start_time.split(':');
                      hours = ((+hours % 12) || 12).toString();
                      return `${hours}:${minutes}`;
                    })()
                    : '-'}
                </td>
                <td>
                  {item.end_time
                    ? (() => {
                      let [hours, minutes] = item.end_time.split(':');
                      hours = ((+hours % 12) || 12).toString();
                      return `${hours}:${minutes}`;
                    })()
                    : '-'}
                </td>


                <td>{item.plan_name}</td>
                <td>{item.total_amount}</td>
                <td>{new Date(item.created_at).toISOString().slice(0, 16).replace("T", " ")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="pagination">
        <div className="showing-entries">
          Showing {indexOfFirstEntry} to {indexOfLastEntry} of {totalEntries} entries
        </div>
        <button
          className="prev-button"
          onClick={handlePrevPage}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        {renderPagination()}
        <button
          className="next-button"
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Summer;